import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import { createPageUrl } from './utils';

// Import pages
import Home from './Pages/Home';
import Photobooth from './Pages/Photobooth';
import Gallery from './Pages/Gallery';
import Events from './Pages/Events';
import Pricing from './Pages/Pricing';
import Contact from './Pages/Contact';
import Dashboard from './Pages/Dashboard';
import HowItWorks from './Pages/HowItWorks';
import CustomCharacter from './Pages/CustomCharacter';
import Privacy from './Pages/Privacy';
import Terms from './Pages/Terms';
import Admin from './Pages/Admin';
import Blog from './Pages/Blog';
import BlogPost from './Pages/BlogPost';
import FAQ from './Pages/FAQ';
import Login from './Pages/Login';
import AdminUserGenerations from './Pages/AdminUserGenerations';
import TabletPhotobooth from './components/photobooth/TabletPhotobooth';
import CameraTest from './Pages/CameraTest';
import PaymentTest from './components/payment/PaymentTest';
import ProfessionalPrintPanel from './components/photobooth/ProfessionalPrintPanel';
import DownloadPrintServer from './Pages/DownloadPrintServer';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/photobooth" element={<Photobooth />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/events" element={<Events />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/custom-character" element={<CustomCharacter />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/users/:id" element={<AdminUserGenerations />} />
        <Route path="/tablet" element={<TabletPhotobooth />} />
        <Route path="/camera-test" element={<CameraTest />} />
        {/* <Route path="/payment-test" element={<PaymentTest />} /> */}
        <Route path="/professional-print" element={<ProfessionalPrintPanel />} />
        <Route path="/download" element={<DownloadPrintServer />} />
        <Route path="/print-server" element={<DownloadPrintServer />} />
      </Routes>
    </Layout>
  );
}

export default App;
